"use client";
import { Flex, Link, Text } from "@chakra-ui/react";
import { useMemo, useState, MouseEvent, useEffect } from "react";

/* eslint-disable @typescript-eslint/no-explicit-any */
interface PortableTextProps {
  blocks: any[];
}

export const SanityOutlinedHeaders = (props: PortableTextProps) => {
  const [headingId, setHeadingId] = useState<string | null>(null);
  const isActive = (id: string) => headingId === id;
  useEffect(() => {
    const headings = props.blocks
      .filter(
        (block) =>
          block._type === "block" &&
          block.style.includes("h") &&
          block.style !== "h6",
      )
      .map((block) => ({
        id: block._key as string,
        offsetTop: document.getElementById(block._key as string)?.offsetTop,
      }));
    window.addEventListener("scroll", () => {
      const scrollPosition = window.scrollY;
      for (let i = 0; i < headings.length; i++) {
        const maxIndex = Math.min(headings.length - 1, i + 1);
        if (
          headings[i].offsetTop! <= scrollPosition &&
          headings[maxIndex].offsetTop! > scrollPosition
        ) {
          setHeadingId(headings[i].id);
        } else if (scrollPosition < headings[0].offsetTop!) {
          setHeadingId(null);
        }
      }
    });
  }, []);

  const listHeading = useMemo(() => {
    return props.blocks
      .filter(
        (block) =>
          block._type === "block" &&
          block.style.includes("h") &&
          block.style !== "h6",
      )
      .map((block) => {
        const ml = ["h1", "h2"].includes(block.style) ? 0 : 4;
        return {
          text: block.children[0].text as string,
          id: block._key as string,
          level: block.style,
          ml,
        };
      });
  }, [props.blocks]);

  const handleScroll = (e: MouseEvent<HTMLAnchorElement, any>, id: string) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  const onOutlineClick = (
    e: MouseEvent<HTMLAnchorElement, any>,
    id: string,
  ) => {
    handleScroll(e, id);
  };
  return (
    <Flex
      p={{ base: 3, md: 6 }}
      flexDir="column"
      rounded="3xl"
      pos="sticky"
      top={8}
      left={2}
      shadow="shadow"
    >
      <Text textStyle="lg" mb={4} fontWeight="semibold" color="primary.600">
        Content
      </Text>
      {listHeading.map((heading) => (
        <Link
          href={`#${heading.id}`}
          key={heading.id}
          textDecor="none"
          w="full"
          onClick={(e) => onOutlineClick(e, heading.id)}
          outline="none"
          borderBottom="none"
          ml={{ base: 0, md: heading.ml }}
        >
          <Text
            textStyle={["h1", "h2"].includes(heading.level) ? "sm" : "xs"}
            fontWeight="semibold"
            cursor="pointer"
            color={isActive(heading.id) ? "primary.500" : "themeColor.fg.body"}
            py={0.5}
            borderRadius="md"
            _hover={{
              bgColor: { _light: "neutral.200", _dark: "neutral.800" },
            }}
            w="full"
            lineHeight={2}
          >
            {heading.text}
          </Text>
        </Link>
      ))}
    </Flex>
  );
};
